import React from 'react';
import { Badge } from './ui/badge';
import { Card, CardContent } from './ui/card';
import { ArrowRight, Settings, Network, BarChart3 } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      number: 1,
      title: 'Setup durch unsere Agentur',
      subtitle: 'Einmaliger Online-Termin (ca. 2 Stunden)',
      description: 'Wir als Agentur setzen deinen persönlichen LinkedIn AI-Agent komplett für dich auf. Wir füttern ihn mit allen wichtigen Informationen: Deine Firma, dein Produkt, deine Zielgruppe und vor allem deinen individuellen Kommunikationsstil. Du lieferst die Infos – wir erledigen den Rest.',
      icon: <Settings className="w-8 h-8 text-white" />,
      details: [
        'Wir trainieren deinen AI-Agent',
        'Firmendaten & Produktinfos einspeisen',
        'Deinen Sprachstil analysieren',
        'Zielgruppen-Definition & Setup'
      ]
    },
    {
      number: 2,
      title: 'AI + Experten arbeiten für dich',
      subtitle: '0 Minuten Aufwand für dich täglich',
      description: 'Dein AI-Agent formuliert personalisierte LinkedIn-Nachrichten in deinem Stil. Unsere LinkedIn-Experten prüfen jede Nachricht, bevor sie rausgeht. Diese Kombination aus AI-Effizienz und menschlicher Qualitätskontrolle sorgt für über 60% Rückmelderate. Du behältst die Kontrolle, sparst aber täglich Stunden.',
      icon: <Network className="w-8 h-8 text-white" />,
      details: [
        'AI formuliert Nachrichten in deinem Stil',
        'LinkedIn-Experten prüfen jede Nachricht',
        'Über 60% Rückmelderate',
        'Kontinuierliche Ansprache von Entscheidern'
      ]
    },
    {
      number: 3,
      title: 'Feedback & Optimierung',
      subtitle: 'Nur 30 Minuten jeden Monat',
      description: 'In monatlichen Reporting-Meetings gibst du Feedback zu den Ergebnissen. Dein AI-Agent lernt aus jeder Rückmeldung und wird kontinuierlich besser. Die Nachrichten werden präziser, die Response-Rate steigt.',
      icon: <BarChart3 className="w-8 h-8 text-white" />,
      details: [
        'Feedback-Session mit deinem AI-Agent',
        'KPI-Auswertung & Performance-Tracking',
        'AI lernt aus jedem Gespräch',
        'Kontinuierliche Optimierung der Ansprache'
      ]
    }
  ];

  return (
    <section id="process" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <Badge className="bg-cyan-100 text-cyan-700">So funktioniert's</Badge>
          <h2 className="text-4xl font-bold text-slate-900">
            In 3 Schritten zu deinem Done-for-you LinkedIn-Service
          </h2>
          <p className="text-xl text-slate-600">
            Wir als Agentur übernehmen alles – du investierst nur 30 Minuten pro Monat
          </p>
        </div>

        <div className="space-y-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative">
              {/* Connecting Line */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute left-16 top-32 w-0.5 h-24 bg-gradient-to-b from-blue-300 to-cyan-300" />
              )}
              
              <Card className="border-2 hover:border-blue-300 transition-all duration-300 hover:shadow-2xl overflow-hidden">
                <CardContent className="p-0">
                  <div className="grid lg:grid-cols-12 gap-0">
                    {/* Step Number & Icon */}
                    <div className="lg:col-span-2 bg-gradient-to-br from-blue-600 to-cyan-600 p-8 flex flex-col items-center justify-center text-white">
                      <div className="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4">
                        {step.icon}
                      </div>
                      <div className="text-6xl font-bold opacity-50">
                        {step.number}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="lg:col-span-10 p-8 lg:p-12">
                      <div className="space-y-4">
                        <div>
                          <h3 className="text-3xl font-bold text-slate-900 mb-2">
                            Schritt {step.number}: {step.title}
                          </h3>
                          <p className="text-blue-600 font-semibold">
                            {step.subtitle}
                          </p>
                        </div>

                        <p className="text-lg text-slate-600 leading-relaxed">
                          {step.description}
                        </p>

                        <div className="grid md:grid-cols-2 gap-3 pt-4">
                          {step.details.map((detail, detailIdx) => (
                            <div key={detailIdx} className="flex items-center gap-2">
                              <ArrowRight className="w-5 h-5 text-blue-500 flex-shrink-0" />
                              <span className="text-slate-700">{detail}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
